import React, { useEffect, useRef, useState } from "react";

import {
    View,
    ScrollView,
    Image,
    Platform
} from "react-native";

import User from "../../data/user/User";
import NavBarButton from "../../components/NavBar/NavBarButton";
import { IcClose, IcLiliStar } from "../../utils/Icons";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import Alert from "../../components/Notification/Alert";
import AppTheme, { dark_blue, dark_grey_blue_70, dark_purple, dark_yellow, light_yellow, off_white, white70 } from "../../utils/Theme";
import Images, { bundleImage } from "../../../specific/utils/Images";
import Text from "../../components/ReactNative/Text";
import Fonts from "../../Theme/Fonts";
import SVGView from "../../utils/SvgView";
import LinkButton from "../../designSystem/Buttons/LinkButton";
import ComponentProps from "../../../specific/utils/Interfaces/ComponentProps";
import PremiumSubBlock from "../../../specific/screens/Subscription/PremiumSubBlock";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import Modal from "../../../specific/components/Modal/Modal";
import PremiumArgumentsScreen from "./PremiumArgumentsScreen";
import { EventRegister } from "../../utils/EventListeners";

interface SubscriptionPaywallProps extends ComponentProps {

}

const SubscriptionPaywall = (props: SubscriptionPaywallProps) => {

    const user: User = User.getInstance();
    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const [showArguments, setShowArguments] = useState<boolean>(false);

    const { fullScreenWidth, fullScreenHeight, availableScreenSize } = useSpecificSize();
    let screenSize: number = availableScreenSize - appTheme.pixelPerfect(20);
    if (screenSize > 1280) {
        screenSize = 1280;
    }
    const alertRef = useRef<Alert>(null);

    const mainColor: string = user.profile === "family" ? light_yellow : dark_purple;
    const backgroundColor: string = user.profile === "family" ? "#354F84" : off_white;
    const mainTextColor: string = user.profile === "family" ? "#FFFFFF" : dark_blue;
    const titleColor: string = user.profile === "family" ? dark_blue : "#FFFFFF";

    const onCloseRequest = () => {
        Navigation.dismissModalInView({ componentId: props.componentId })
    }

    const renderHeader = (): React.JSX.Element => {
        const imageToUse: number | bundleImage = user.profile === "family" ? images.icLiliAtHomeCircle : user.profile === "animator" ? images.icLiliAtExtracurricularCircle : images.icLiliAtSchoolCircle;
        return <View style={{ width: screenSize, flexDirection: "row", alignItems: "flex-start", paddingHorizontal: appTheme.pixelPerfect(10) }}>
            <View style={{ width: appTheme.pixelPerfect(40) }} />
            <View style={{ flex: 1, alignItems: "center" }}>
                <Image source={imageToUse} style={{ width: appTheme.pixelPerfect(70), height: appTheme.pixelPerfect(70) }} />
            </View>
            <NavBarButton icon={IcClose} action={onCloseRequest} />
        </View>
    }

    const renderChapo = (): string => {
        if (user.profile === "family") {
            return "Les crises, les devoirs, le coucher : des solutions concrètes pour votre quotidien de parent.";
        } else if (user.profile === "animator") {
            return "Déployer un programme sur les compétences psychosociales en périscolaire, accueil de loisirs, centre social et médiathèque pour les 3-15 ans.";
        }
        return "Développez les compétences psychosociales et langagières de vos élèves avec Lili, l’assistant pédagogique des super-profs !";
    }

    const renderBody = (): string => {
        if (user.profile === "family") {
            return "Bénéficiez de l’intégralité des conseils d'experts en neurosciences et psychologie pour comprendre votre enfant à chaque âge, l'aider à grandir en confiance et vivre plus sereinement votre quotidien de parent.";
        } else if (user.profile === "animator") {
            return "Outiller et accompagner les animateurs et les référents familles avec la ressource numérique audio et la mallette des super-anims : 7 projets d’animation clé-en-main, les plannings pour le périscolaire et les mercredis/vacances, des modules pour développer la posture ou le bien-être des animateurs.";
        }
        return "Profitez de l’intégralité des séquences pédagogiques, des programmations et des activités audio adaptées à chaque niveau (maternelle, élémentaire, collège) + 20h de podcast d’auto-formation dont le nouveau module “enseignez avec les neurosciences” conçu avec Grégoire Borst.";
    }

    const renderInfoButtonTitle = (): string => {
        if (user.profile === "family") {
            return "Ce que comprend l'abonnement";
        } else if (user.profile === "animator") {
            return "En savoir plus";
        }
        return "Tout ce que cela comprend";
    }

    const onShowSubInfoRequest = () => {
        setShowArguments(true);
    }

    const onSubscriptionConfirmed = () => {
        onCloseRequest();
    }

    const renderContent = (): React.JSX.Element[] => {
        
        return [
            renderHeader(),
            <Text style={{ width: screenSize, color: mainTextColor, fontFamily: Fonts.primary.bold, fontSize: appTheme.pixelPerfectForFont(9), padding: appTheme.pixelPerfect(10), textAlign: "center" }}>
                {renderChapo()}
            </Text>,
            <View style={{ width: screenSize, backgroundColor: "#FFFF", overflow: "hidden", borderRadius: appTheme.pixelPerfect(10), alignItems: "center", paddingBottom: appTheme.pixelPerfect(20) }}>
                <View style={{ width: screenSize, height: appTheme.pixelPerfect(45), backgroundColor: mainColor, flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                    <View style={{ width: appTheme.pixelPerfect(24), height: appTheme.pixelPerfect(24), borderRadius: appTheme.pixelPerfect(12), backgroundColor: dark_yellow, justifyContent: "center", alignItems: "center" }}>
                        <SVGView Component={IcLiliStar} size={appTheme.pixelPerfect(14)} color="#FFFFFF" />
                    </View>
                    <Text style={{ paddingStart: appTheme.pixelPerfect(10), color: titleColor, fontFamily: Fonts.primary.bold, fontSize: appTheme.pixelPerfectForFont(10) }}>
                        LILI PREMIUM
                    </Text>
                </View>
                <Text style={{ padding: appTheme.pixelPerfect(10), color: dark_blue, fontFamily: Fonts.primary.regular, fontSize: appTheme.pixelPerfectForFont(8), textAlign: "center" }}>
                    {renderBody()}
                </Text>
                <LinkButton onPress={onShowSubInfoRequest} title={renderInfoButtonTitle()} />
                <PremiumSubBlock onSubscriptionConfirmed={onSubscriptionConfirmed} screenSize={screenSize} onPlanSelection={(plan) => console.log({ plan })} />
            </View>
        ]
    }

    return <View style={{ width: availableScreenSize, height: fullScreenHeight, alignItems: "center", paddingTop: appTheme.topInsets + 20, backgroundColor }}>
        <ScrollView style={{ flex: 1 }}>
            <View style={{ width: screenSize, height: fullScreenHeight }}>
                {renderContent()}
            </View>
            <Alert ref={alertRef} />
        </ScrollView>
        <Modal transparent={true} visible={showArguments}>
            <View style={{ width: fullScreenWidth, height: fullScreenHeight, backgroundColor: dark_grey_blue_70 }}>
                <PremiumArgumentsScreen onCloseRequest={() => setShowArguments(false)} screenSize={ Platform.OS === "web" ? screenSize : availableScreenSize} />
            </View>
        </Modal>
    </View>

}

export default SubscriptionPaywall;